import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tax-invoice-retail-form',
  templateUrl: './tax-invoice-retail-form.component.html',
  styleUrls: ['./tax-invoice-retail-form.component.css']
})
export class TaxInvoiceRetailFormComponent implements OnInit {
  title="Tax Invoice Retail";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/sales-orders/tax-invoice-retail/tax-invoice-retail-form/tax-invoice-retail-form.component.ts